import React from 'react'

import AriaLogin from './components/AriaLogin'
import INMLogo from './logo-inm.png'
import { getUser, getToken, getUserId, removeUserId, removeUser, removeToken } from './utils/auth'
import { isEmpty, log, getUrlService } from './utils/'
// const AriaLogo =
//   'data:image/png;base64,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'

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Alert from '@material-ui/lab/Alert'
import LinearProgress from '@material-ui/core/LinearProgress'
import Grid from '@material-ui/core/Grid'

import UserForm from './components/UserForm'
const widthPaper = 680
const useStyles = makeStyles((theme) => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(widthPaper + theme.spacing(2) * 2)]: {
      width: widthPaper,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(widthPaper + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  title: {
    marginBottom: theme.spacing(6),
  },
  list: {
    marginTop: theme.spacing(4),
  },
  listItem: {
    padding: theme.spacing(1, 0),
  },
  buttons: {
    display: 'flex',
    alignItems: 'center'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  buttonLeft: {
    flexGrow: 1
  },
  info: {
    marginTop: theme.spacing(4),
  }
}));

const UserPage = ({userinfo}) => {
  const classes = useStyles();
  const [error, setError] = React.useState(undefined)
  const [isLoading, setIsLoading] = React.useState(false)
  const [info, setInfo] = React.useState(undefined)
  const [expiredQuota, setExpiredQuota] = React.useState(false)

  const [userdata, setUserdata] = React.useState(undefined)
  // const [userHistory, setUserHistory] = React.useState(undefined)
  const [userConsumation, setUserConsomtion] = React.useState(undefined)
  const [userReset, setUserReset] = React.useState(undefined)
  
  // ////////////////////////////////
  // Effects
  // ////////////////////////////////

  // Load user info
  React.useEffect(() => {
    setIsLoading(true)
    setExpiredQuota(false)
    setError(false)

    const pp = ['inm', getUserId()]

    const _url = getUrlService('users', pp)
    log(_url, 'URL User data service', 'info')
    // eslint-disable-next-line no-undef
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 403) {
          setExpiredQuota(true)
          return response.json()
        } else if (response.status === 404) {
          const errmsg = 'Authentication service not found'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        } else if (response.status === 401) {
          const errmsg = response.statusText || 'No handled error'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        } else {
          const errmsg = response.statusText || 'No handled error'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        }
      })
      .then((json) => {
        setIsLoading(false)
        log(json, 'Response userdata: ')
        if (json.data) {
          setUserdata(json.data)
        }

        if (json.error) {
          console.error(json.message)
          setError(json.message)
        }
      })
      .catch((error) => {
        console.error(error)
        setError(error.toString())
        setIsLoading(false)
      })
  }, [])

  // Load user historique
  React.useEffect(() => {
    setIsLoading(true)
    setExpiredQuota(false)
    setError(false)
    setInfo(undefined)

    const pp = ['inm', 'history']

    const _url = getUrlService('users', pp)
    log(_url, 'URL User history service', 'info')
    // eslint-disable-next-line no-undef
    fetch(_url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 403) {
          setExpiredQuota(true)
          return response.json()
        } else if (response.status === 404) {
          const errmsg = 'Authentication service not found'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        } else if (response.status === 401) {
          const errmsg = response.statusText || 'No handled error'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        } else {
          const errmsg = response.statusText || 'No handled error'
          setError(errmsg)
          setIsLoading(false)
          return Promise.reject(new Error(errmsg))
        }
      })
      .then((json) => {
        setIsLoading(false)
        log(json, 'Response user history: ')
        if (json.data && json.data.consume) {
          setUserConsomtion((json.data.consume*0.001).toFixed(3))
        }
      })
      .catch((error) => {
        setError(error.toString())
        setIsLoading(false)
      })
  }, [])

  React.useEffect(() => {
    if (userdata && userdata.is_temporary) {
      setUserReset({'old_password': '', 'new_password': ''})
    }
  }, [userdata])

  const resetHandler = React.useCallback(
    (e) => {
      setUserReset({'old_password': '', 'new_password': ''})
    }, []
  )
  const handleSubmitChangePassword = (e) => {
    e.preventDefault()

    // Fetch update the user data
    const pp = ['inm', 'password']
    const _url = getUrlService('users', pp)
    log(_url, 'URL User password PUT', 'info')
    log(userReset, 'data: ')
    // eslint-disable-next-line no-undef
    setIsLoading(true)
    setError(false)
    setInfo(undefined)
    fetch(_url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: JSON.stringify(userReset)
    })
      .then((response) => response.json())
      .then((json) => {
        setIsLoading(false)
        log(json, 'Response user password change: ')

        if (json.error) {
          setError(json.error.message)
        } else {
          setInfo('Le nouveau mot de passe a été bien mis à jour. La page va être rechargée...')
          setUserReset(undefined)

          // Reload la page
          setTimeout(
            () => {
              removeUserId()
              removeUser()
              removeToken()
              document.location.reload()
            }, 3000
          )
        }
      })
      .catch((error) => {
        setError(error.toString())
        setIsLoading(false)
      })
  }

  const handleChange = (field) => (e) => {
    setUserReset(x => {
      return {
        ...x,
        [field]: e.target.value
      }
    })
  }

  const handleUserdataSubmit = React.useCallback(
    (vals) => {
      setUserdata(vals)
      log(vals, 'new user data: ')

      // Fetch update the user data
      const pp = ['inm', getUserId().toString()]
      const _url = getUrlService('users', pp)
      log(_url, 'URL User data PUT', 'info')
      // eslint-disable-next-line no-undef
      setIsLoading(true)
      setError(false)
      setInfo(undefined)
      fetch(_url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(vals)
      })
        .then((response) => response.json())
        .then((json) => {
          setIsLoading(false)
          log(json, 'Response user update data: ')
          if (json.data) {
            setUserdata(json.data)
            setInfo("Les données d'utilisateur ont été bien mises à jour!")
          }
        })
        .catch((error) => {
          setError(error.toString())
          setIsLoading(false)
        })
    }, []
  )

  // Render
  return (
    <React.Fragment>
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography className={classes.title} component="h1" variant="h4" align="center">
            Information d'utilisateur
          </Typography>

          {userdata && !userdata.is_temporary && <UserForm userdata={userdata} submitHandler={handleUserdataSubmit}/>}

          {userConsumation && userdata && !userdata.is_temporary && <React.Fragment>
            <List disablePadding className={classes.list}>
              <ListItem className={classes.listItem}>
                <ListItemText primary={'Consommation du mois'} />
                <Typography variant="body2">{userConsumation} KB</Typography>
              </ListItem>
            </List>
          </React.Fragment>}

          {userdata && userdata.is_temporary && (
            <Alert severity='warning' className={classes.alert}>
              {`Le compte est provisoire. Réinitialisez le mot de passe s'il vous plaît!`}
            </Alert>
          )}

          <Divider />
          {!expiredQuota && <div className={classes.buttons}>
            <div className={classes.buttonLeft}>
              <Link 
                component='button'
                onClick={resetHandler} 
                className={classes.button}
              >
                Réinitialiser le mot de passe
              </Link>
            </div>
          </div>}

          {userReset && 
          <React.Fragment>
            <form noValidate autoComplete="off">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    required
                    type='password'
                    id="old_password"
                    name="oldPassword"
                    label="Ancien mot de passe"
                    value={userReset ? userReset.old_password || '' : ''}
                    fullWidth
                    onChange={handleChange('old_password')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    type='password'
                    id="new_password"
                    name="newPassword"
                    label="Nouveau mot de passe"
                    value={userReset ? userReset.new_password || '' : ''}
                    fullWidth
                    onChange={handleChange('new_password')}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Link
                    component='button'
                    type='submit'
                    color="primary"
                    style={{textDecoration: 'none', float: 'right'}}
                    onClick={handleSubmitChangePassword}
                  >
                    Valider
                  </Link>
                </Grid>
              </Grid>
            </form>
          </React.Fragment>}
          <div className={classes.info}>
          {isLoading && <LinearProgress className={classes.linearProgress} />}
          {error && (
            <Alert severity='error' className={classes.alert}>
              {error || "Erreur lors de la mise à jour des données d'utilisateur!"}
            </Alert>
          )}
          {info && (
            <Alert 
              severity='success' 
              className={classes.alert}
              onClose={() => setInfo(undefined)}
            >
              {info}
            </Alert>
          )}
          </div>
        </Paper>
        
      </main>
    </React.Fragment>
  )
}

// ////////////////////
// Render function
// ////////////////////
const App = () => {
  // Token handler
  // ---------------
  const [tokenInCookie, setTokenInCookie] = React.useState(getToken())
  const [userId, setUserId] = React.useState(getUserId())
  const tokenHandler = React.useCallback(
    (token, uid) => {
      setUserId(uid)
      setTokenInCookie(token)
    }, []
  )

  // ///////////////////////////////
  // Render 
  // ///////////////////////////////
  return (
    <div className="container">
      {
      ((tokenInCookie && tokenInCookie.length>0 && userId) ?
        <UserPage
          logo={INMLogo}
          userinfo={getUser()}
        />
        : 
        <AriaLogin 
          tokenHandler={tokenHandler} 
          // anonymous={{username: process.env.REACT_APP_ANONYMOUS_USER, password: process.env.REACT_APP_ANONYMOUS_PWD}}
        />)
      }
    </div>
  )
}

export default App
